import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicRefundInProgress({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 17 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7 1.5a.7.7 0 00-1-1l-2 2a.7.7 0 000 1l2 2a.7.7 0 001-1l-.81-.8h4.86a1.05 1.05 0 110 2.1H10a.7.7 0 100 1.4h.75a2.45 2.45 0 100-4.9H5.89l.8-.8zm-.5 5.53l4.2.93.06.02c.6.23 1 .94.9 1.64l2.68-.96c.4-.14.84-.09 1.2.15.3.2.53.5.65.85.29.8.07 1.8-.82 2.39-.9.59-4.35 2.5-4.58 2.58-.04 0-.07.02-.11.03-.4.13-.92.3-2.1.07l-2.77-.5-.1-.03c-.33-.07-.89-.2-1.61-.02v.45a.66.66 0 01-.66.59H.66a.66.66 0 01-.66-.66V7.05c0-.37.3-.66.66-.66h2.48c.33 0 .6.24.65.56l.01.82c1.16-.6 1.94-.86 2.4-.74zM5.9 8.3h-.06c-.2-.01-.7.18-1.44.58l-.19.1-.4.23-.01 3.68.4-.04c.4-.05.64-.04 1 .02l.2.04 3.15.52c.51.1 1.05.08 1.55-.07 0 0 2.7-1.32 4.53-2.4.44-.34.17-1.43-.54-1.1l-1.12.44c-1.04.4-2.43.96-2.57 1l-.06.02c-.2.05-.43.12-.62.12-.11 0-.22-.01-.32-.04l-.1-.03-2.27-.56a.66.66 0 01.22-1.3l.1.02 2.31.57h.1c.41-.17.43-.72.32-.86l-.04-.02L5.9 8.3zm-4.58-.6h1.17v6.2H1.32V7.7z"
      />
    </svg>
  );
}

SvgBasicRefundInProgress.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicRefundInProgress.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicRefundInProgress svgRef={ref} {...props} />
));
export default ForwardRef;
